var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.628 15.5179C18.1754 21.3299 10.2003 23.0236 5.62899 18.4947C1.14658 14.054 2.53431 6.00881 8.42818 3.43146",
    stroke: "#676767",
    strokeWidth: 1.57,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8667 12.2552C19.7174 12.2552 20.6427 12.2552 21.2403 11.4267C21.2627 11.3958 21.2998 11.3402 21.3199 11.3078C21.8566 10.4386 21.58 9.77084 21.0268 8.4353C20.5251 7.22424 19.7899 6.12384 18.863 5.19693C17.9361 4.27003 16.8357 3.53477 15.6246 3.03313C14.2891 2.47993 13.6213 2.20333 12.7521 2.74005C12.7197 2.7601 12.6641 2.79722 12.6332 2.81955C11.8047 3.41715 11.8047 4.34249 11.8047 6.19316V8.26245C11.8047 10.1447 11.8047 11.0858 12.3894 11.6705C12.9741 12.2552 13.9152 12.2552 15.7975 12.2552H17.8667Z",
    stroke: "#676767",
    strokeWidth: 1.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.38b3ebfff1c427bada851480d25b1cd5.svg";
export { ForwardRef as ReactComponent };